<template>
  <v-container class="leaderboard">
    <div class="charity-logo-container">
      <img v-if="charityId === 4" src="@/assets/charity-4.png" alt="Charity Logo" class="charity-logo">
      <img v-if="charityId === 5" src="@/assets/charity-5.png" alt="Charity Logo" class="charity-logo">
      <img v-if="charityId === 6" src="@/assets/charity-6.png" alt="Charity Logo" class="charity-logo">
    </div>
    <v-row class="text-center">
      <v-col class="text-center leaderboard-header">
        <h1>Dedicate Your Practice 2026</h1>
        <h2>Wisdom in Service</h2>
      </v-col>
    </v-row>

    <div class="main-stats">
      <div class="main-stats--item">
        <h3>Total<br />Participants</h3>
        <p>{{ memberCount }}</p>
      </div>
      <div class="main-stats--item">
        <h3>Total<br />Classes</h3>
        <p>{{ memberClassTotal }}</p>
      </div>
      <div class="main-stats--item">
        <h3>Total<br />$ Pledged</h3>
        <p>${{ memberDonationTotal }}</p>
      </div>
    </div>

    <div class="stats-container">
      <v-row>
        <v-col>
          <div class="stats-sheet">
            <v-row>
              <v-col class="py-0">
                <h2 class="text-center">30 Class Sign Ups</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                <v-chip
                  v-for="member in memberThirtyList"
                  :key="member.id"
                  color="#A96902"
                  outlined
                  class="ma-1">
                    {{ formatName(member) }} - {{ member.totalClasses }}
                </v-chip>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="stats-sheet">
            <v-row>
              <v-col class="py-0">
                <h2 class="text-center">45 Class Sign Ups</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                <v-chip
                  v-for="member in memberFortyFiveList"
                  :key="member.id"
                  color="#A96902"
                  outlined
                  class="ma-1">
                    {{ formatName(member) }} - {{ member.totalClasses }}
                </v-chip>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="stats-sheet">
            <v-row>
              <v-col class="py-0">
                <h2 class="text-center">60 Class Sign Ups</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                <v-chip
                  v-for="member in memberSixtyList"
                  :key="member.id"
                  color="#A96902"
                  outlined
                  class="ma-1">
                    {{ formatName(member) }} - {{ member.totalClasses }}
                </v-chip>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
//import { mapGetters } from 'vuex'
//import { DateTime } from 'luxon'
//import { orderBy } from 'lodash'
//import HeartLoader from '../components/HeartLoader.vue'

export default {
  name: '2026LeaderboardPage',

  components: {
//    HeartLoader
  },

  data() {
    return {
      charityId: 4,
      timer: null,
    }
  },

  computed: {
    members() {
      return this.$store.state.memberLeaderboard
    },
    memberLeaderboardLoading() {
      return this.$store.state.memberLeaderboardLoading
    },
    memberCount() {
      return (this.members) ? this.members.length : 0
    },
    memberClassTotal() {
      if (this.members) {
        let count = 0
        this.members.forEach(member => {
          count = count + member.totalClasses
        })

        return count
      } else {
        return 0
      }
    },
    memberDonationTotal() {
      if (this.members) {
        let total = 0

        this.members.forEach(member => {
          let modifier = 0
          if (member.pledgeClasses === 24) modifier = 0
          if (member.pledgeClasses === 30) modifier = 10
          if (member.pledgeClasses === 45) modifier = 15
          if (member.pledgeClasses === 60) modifier = 20

          total = total + 10 + modifier
        })

        return total
      } else {
        return 0
      }
    },
    memberTotalClasses() {
      if (this.members) {
        let total = 0

        this.members.forEach(member => {
          total = total + member.totalClasses
        })

        return total
      } else {
        return 0
      }
    },
    memberThirtyList() {
      if (this.members) {
        return this.members.filter(member => (member.pledgeClasses === 30 || member.pledgeClasses === 24))
      } else {
        return []
      }
    },
    memberFortyFiveList() {
      if (this.members) {
        return this.members.filter(member => member.pledgeClasses === 45)
      } else {
        return []
      }
    },
    memberSixtyList() {
      if (this.members) {
        return this.members.filter(member => member.pledgeClasses === 60)
      } else {
        return []
      }
    }
  },

  methods: {
    formatName(member) {
      const first = member.firstName
      const last = (member.lastName) ? member.lastName.charAt(0) + '.' : ''

      return `${first} ${last}`
    },
    
    async getData() {
      await this.$store.dispatch('getMemberLeaderboard', this.charityId)
    }
  },

  async beforeMount() {
    this.getData()

    this.timer = setInterval(() => {
      if (this.charityId !== 6) {
        this.charityId = this.charityId + 1
      } else {
        this.charityId = 4
      }
      
      this.getData()
    }, 30000)
  }
}
</script>

<style lang="scss">
.v-main__wrap {
  background-image: url('../assets/2026-bg.jpg');
}

.main-body {
  background: transparent;
}

.charity-logo-container {
  display: block;
  position: absolute;
  width: 100px;
  height: 100px;
  left: 70px;
  top: 15px;
  background-color: #ffffff;
  padding: 10px;
  border-radius: 8px;

  img {
    max-width: 100%;
  }
}

.leaderboard-header {
  color: #ffffff;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.7);
}

.main-stats {
  width: 100%;
  display: block;
}

.main-stats--item {
  text-align: center;
  display: block;
  position: absolute;
  width: 200px;
  margin: 1.5%;
  padding: 20px;

  p {
    font-size: 30px;
    font-weight: 700;
  }
}

.main-stats--item:nth-of-type(1) {
  left: 112px;
  top: 115px;
}

.main-stats--item:nth-of-type(2) {
  left: 365px;
  top: 115px;
}

.main-stats--item:nth-of-type(3) {
  left: 615px;
  top: 115px;
}

.stats-container {
  position: relative;
  top: 150px;
}

.stats-sheet {
  border-radius: 10px;
  border: 1px solid #A96902;
  background-color: #ffffff;
  padding: 20px;
  min-height: 250px;
}
</style>